export default __webpack_public_path__ + "static/media/bp-13.27fefc90.jpg";